import i18next, { use as i18use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import backendModule from './backendModule';
import { getRetailUnitAndLanguage } from '../network/utils/getRetailUnitAndLanguage';

export const initLanguage = async () => {
  if (i18next.isInitialized) {
    return i18next;
  }

  const { retailUnit, language } = getRetailUnitAndLanguage();
  const cultureCode = `${language.toLowerCase()}-${retailUnit.toUpperCase()}`;
  const queries = new URLSearchParams(globalThis.location.search);
  return i18use(initReactI18next)
    .use(backendModule)
    .init({
      debug: process.env.NODE_ENV === 'development',
      saveMissing: true,
      interpolation: {
        escapeValue: false,
        format: undefined,
      },
      fallbackLng: false,
      ns: ['translations', 'profile'],
      load: 'currentOnly',
      defaultNS: 'translations',
      lng: queries.has('showKeys') ? 'cimode' : cultureCode,
    });
};
